export default __webpack_public_path__ + "static/api-iframes-f553cb02bb959d600e00eca28ffe3711.webp";